import { Link } from "react-router-dom";
import Logo from "./Logo";
import FxTicker from "./FxTicker";

const columns = [
  {
    title: "Products",
    links: [
      { label: "Payments", to: "/products#payments" },
      { label: "Payouts", to: "/products#payouts" },
      { label: "Multi-Currency Accounts", to: "/products#accounts" },
      { label: "FX", to: "/products#fx" },
      { label: "Payment Links", to: "/products#payment-links" },
      { label: "APIs", to: "/products#apis" },
    ],
  },
  {
    title: "Solutions",
    links: [
      { label: "Global Businesses", to: "/solutions#global-businesses" },
      { label: "Fintechs", to: "/solutions#fintechs" },
      { label: "Marketplaces", to: "/solutions#marketplaces" },
      { label: "Remittance", to: "/solutions#remittance" },
      { label: "Platforms", to: "/solutions#platforms" },
      { label: "Enterprises", to: "/solutions#enterprises" },
    ],
  },
  {
    title: "Developers",
    links: [
      { label: "Documentation", to: "/developers" },
      { label: "API Reference", to: "/developers#apis" },
      { label: "Sandbox", to: "/developers#sandbox" },
      { label: "Webhooks", to: "/developers#webhooks" },
      { label: "Status", to: "/developers" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/company" },
      { label: "Contact", to: "/contact" },
      { label: "Careers", to: "/careers" },
      { label: "News", to: "/company#news" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", to: "/legal/privacy" },
      { label: "Terms & Conditions", to: "/legal/terms" },
      { label: "Cookie Policy", to: "/legal/cookies" },
      { label: "Compliance", to: "/legal/compliance" },
    ],
  },
];

const Footer = () => (
  <footer className="border-t border-[#E2E8F0] bg-[#F8FAFC]" data-testid="main-footer">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_2fr]">
        <div>
          <Logo />
          <p className="mt-5 font-heading text-xl font-bold text-[#0F172A]">Move money without borders.</p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-[#64748B]">
            One powerful platform to collect, hold, convert and send money across markets.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:grid-cols-5">
          {columns.map((col) => (
            <div key={col.title}>
              <h3 className="text-xs font-semibold uppercase tracking-wider text-[#0F172A]">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      data-testid={`footer-${col.title.toLowerCase()}-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                      className="text-sm text-[#64748B] transition-colors hover:text-[#1E3A6E]"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-14 border-t border-[#E2E8F0] pt-6">
        <FxTicker compact />
      </div>
      <div className="mt-8 flex flex-col gap-3 border-t border-[#E2E8F0] pt-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-[#64748B]">© 2026 Swiftwire Payments. All rights reserved.</p>
        <p className="text-xs text-[#94A3B8]">Fast. Secure. Global.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
